__webpack_public_path__ = __CLIENT_HOLOCRON_MODULE_MAP__.modules['axp-travel-search-flight-hotel'].baseUrl;
import ModuleContainer from './components/TravelSearchPackagesWrapper';
export default ModuleContainer;
;
if (!global.BROWSER) {
  ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
    appCompatibility: "5.x || 6.x"
  });
}
;
if (!global.BROWSER) {
  ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
    requiredExternals: {
      '@americanexpress/one-app-module-wrapper': '^3.4.2',
      '@americanexpress/one-experiments': '^2.1.3',
      '@americanexpress/conditional-features': '^3.0.0',
      '@americanexpress/reactlytics': '^1.2.6',
      '@americanexpress/travel-selectors': '^5.0.0',
      'iguazu': '^3.2.0',
      'iguazu-holocron': '^1.2.0',
      'iguazu-rest': '^1.8.0',
      'react-intl': '^6.3.2',
      'yup': '^0.32.9'
    }
  });
}